import { configureStore } from "@reduxjs/toolkit";
import inputSlice from "../slices/input.slice";
import proposalSlice from "../slices/proposal.slice";
import quoteSlice from "../slices/quote.slice";

export const store = configureStore({
  reducer: {
    input: inputSlice,
    quote: quoteSlice,
    proposal: proposalSlice,
  },
});
